<template>
  <div
    class="progress"
    :class="customClass"
  >
    <div
      v-if="notNanValue"
      class="progress-bar"
      role="progressbar"
      :style="{width: notNanValue/max*100 +'%'}"
      :aria-valuenow="notNanValue"
      :aria-valuemin="min"
      :aria-valuemax="max"
    >
      <div v-if="!grade">
        {{ notNanValue }}%
      </div>
      <div v-else>
        {{ notNanValue }}
      </div>
    </div>
    <div
      v-else
      style="margin-right: auto;margin-left: auto"
    >
      Sin datos
    </div>
  </div>
</template>
<script>
export default {
    name: 'BaseProgress',
    props: {
        value: {
            type: Number,
            required: true,
        },
        min: {
            type: Number,
            required: false,
            default: 0,
        },
        max: {
            type: Number,
            required: false,
            default: 100,
        },
        grade: {
            type: Boolean,
            required: false,
            default: false,
        },
        size: {
            type: String,
            default: 'md',
        },
    },
    computed: {
        notNanValue() {
            return Number.isNaN(this.value) ? 0 : this.value;
        },
        customClass() {
            let customClass = '';

            if (this.size === 'xl') {
                customClass += ' progress--xl';
            }

            return customClass;
        },
    },
};
</script>
<style lang="scss">
  .progress{
    &--xl{
      height: 1.5rem;

      & .progress-bar{
        font-weight: 500;
      }
    }
  }
</style>
